module.exports = __webpack_public_path__ + "img/Apple_logo_black.05497ef7.svg";